import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../../../components/tables/tableContext/TableContext";

import { FleetFeatureDocumentsDataInterface } from "../../../../../../redux/interfaces/fleet.interface";
import { dateToString } from "../../../../../../utils/dateAndTime";

export const fleetFeatureDocumentsTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "Denumire",
    value: "denumire",
    minW: 125,
  },
  {
    label: "Observatii",
    value: "caldoc_obs",
    minW: 125,
  },
  {
    label: "Valabilitate",
    value: "valability",
    minW: 125,
  },
];

export const geFleetFeatureDocumentsTableData = (
  data: FleetFeatureDocumentsDataInterface[],
): TableData[] =>
  data.map((item) => {
    return {
      id: item.id_caldoc,
      crudData: item,
      data: [
        {
          title: item.denumire,
        },
        {
          title: item.caldoc_obs,
        },
        {
          badges: [
            {
              badgeText: dateToString(item.doc_ts_start),
              badgeColor: "warning",
            },
            {
              badgeText: dateToString(item.doc_ts_stop),
              badgeColor: "danger",
            },
          ],
        },
      ],
    };
  });
